import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ActionsBarWrapper as CompiledActionsBarWrapper } from './actionsBarWrapper-compiled';
import { ActionsBarWrapper as EmotionActionsBarWrapper } from './actionsBarWrapper-emotion';
export var ActionsBarWrapper = function ActionsBarWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledActionsBarWrapper, props) : /*#__PURE__*/React.createElement(EmotionActionsBarWrapper, props);
};